import React from 'react';
import { Header } from '../../Layout';
import { Categories } from '../../pages/Categories';

export const UnAuthorizedContent = () => {
  return <Categories />;
};

export const UnAuthorizedHeader = () => <Header />;
